import {Info, Trash2} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { GetRequest } from "../../functions/ApiFunctions";
import { tableColumn } from "../constants/tableColumn";
import { OverlayTrigger,Tooltip } from "react-bootstrap";
import { DataSourceSearch } from "../../functions/HandleSearch";
import ImageWithBasePath from "../../core/img/imagewithbasebath";


const ListUsers = () => {
  const [dataSource,setDataSource] = useState(null)
  const [exportMode, setExportMode] = useState("ALL"); // "ALL" or "INDIVIDUAL"
  const [Search, setSearch] = useState("");

  const fetchData = async () => {
    const res = await GetRequest("user")
    if (res){
      setDataSource(res)
    }
  }
  useEffect(()=>{
    fetchData()
  },[])

  const AllExtraTable = [
            {
      title: "Joined Via",
      dataIndex: "group",
      render:(_,record)=>(<span className="badge badge-primary">{record?.group?.name}</span>),
    },
  ]

// groupId

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      render: (_,record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            

            <OverlayTrigger placement="top" overlay={
              <Tooltip id="printer-tooltip">
                <div>
                  <p>{record?.selfieId ? "Selfie Is Added" : "Selfie Not Added"}</p>
                  <p>{record?.emailVerified ? "Email Is Verified" : "Email Is Not Verified"}</p>
                  {record?.createdAt && (<p>Joined at {new Date(record?.createdAt).toLocaleDateString()}</p>) }
                </div>
              </Tooltip>}>
              <Link className="me-2 p-2" >
                <Info className="feather-edit" style={{color :  record?.selfieId && record?.emailVerified ? "green" : "red"}}/>
              </Link>
            </OverlayTrigger>
            
            {/* <Link
              className="confirm-text p-2"
              to="#"
              // onClick={showConfirmationAlert}
            >
              <Trash2 className="feather-trash-2" />
            </Link> */}
          </div>
        </div>
      ),
    },
  ];

    // Export current dataSource to CSV using columns from tableColumn.users
    const exportToCSV = () => {
        if (!dataSource || dataSource?.length === 0) {
          // still generate headers even if no rows
          const headers = tableColumn.users.map((c) => c.title || c.dataIndex || "");
          const csvContent = headers.join(",") + "\n";
          const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `users_export_${new Date().toISOString().slice(0,10)}.csv`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
          return;
        }

      const cols = tableColumn.users;
      const headers = cols.map((c) => c.title || c.dataIndex || "");

      const escapeField = (value) => {
        if (value === null || value === undefined) return "";
        const str = String(value);
        // Escape double quotes by doubling them
        const escaped = str.replace(/"/g, '""');
        // Wrap in quotes if contains comma, newline or quote
        if (/[",\n]/.test(escaped)) return `"${escaped}"`;
        return escaped;
      };

      const rows = dataSource?.filter(item => exportMode === 'IND' ? item.group === null : true)
      .map((record) =>
        cols
          .map((col) => {
            const key = col.dataIndex;
            let val = record?.[key];
            // If a render function exists on the column try to use it (it may format date etc.)
            if (col.render && typeof col.render === "function") {
              try {
                // render may return JSX or a primitive; try to coerce
                const rendered = col.render(val, record);
                if (rendered && typeof rendered === "object") {
                  // If it's a Date formatting function it often returns a string; fallback to JSON
                  val = String(rendered);
                } else {
                  val = rendered;
                }
              } catch (e) {
                // fallback to raw value
                val = record?.[key];
              }
            } else if (key === "createdAt" && val) {
              // keep same formatting as tableColumn render for createdAt
              try {
                val = new Date(val).toLocaleDateString();
              } catch (e) {
                // leave as-is
              }
            }

            // If value is object (like _count) stringify it
            if (val && typeof val === "object") {
              try {
                val = JSON.stringify(val);
              } catch (e) {
                val = String(val);
              }
            }

            return escapeField(val ?? "");
          })
          .join(",")
      );

      const csvContent = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `users_export_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>User List</h4>
              <h6>Manage your Users</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <Link to={route.addproduct} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Add New Product
            </Link>
          </div> */}
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={Search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <button className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </button>
                </div>
                <div className="me-2">
                  <span className=" ">Total: {DataSourceSearch(Search, ["name", "email",], dataSource?.filter(item => exportMode === 'IND' ? item.group === null : true))?.length ?? "-"}</span>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="btn-group me-2" role="group" aria-label="export mode">
                  <button
                    type="button"
                    className={`btn btn-sm ${exportMode === 'ALL' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setExportMode('ALL')}
                  >
                    All
                  </button>
                  <button
                    type="button"
                    className={`btn btn-sm ${exportMode === 'IND' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => setExportMode('IND')}
                  >
                    Individuals
                  </button>
                </div>

                <button className="btn btn-outline-light" onClick={exportToCSV}>
                  <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                </button>
              </div>

            </div>
            <div className="table-responsive">
              <Table columns={[...tableColumn.users,...(exportMode === 'ALL' ? AllExtraTable : []),...columns]} dataSource={DataSourceSearch(Search, ["name", "email",], dataSource?.filter(item => exportMode === 'IND' ? item.group === null : true))}  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListUsers;
